// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"help-rectangle"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M3 3H21V21H3V3Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M3 3H21V21H3V3Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M12.0002 14.5V14.25C12.0002 13.1454 12.9877 12.2914 13.8553 11.6078C14.5525 11.0585 15.0002 10.2065 15.0002 9.25C15.0002 7.59315 13.657 6.25 12.0002 6.25C10.694 6.25 9.58273 7.08481 9.1709 8.25M12 17.5H12.0039V17.5039H12V17.5Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-help-rectangle')
export default class HelpRectangleIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'help-rectangle',
    }
  }
}
